import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { WebSocketSubject, webSocket } from 'rxjs/webSocket';
import { DriverTemplate } from '../driver-template';
import { ProfileService } from 'src/app/profile/profile.service';
import { VisionService } from '../vision-web/vision.service';
import { Router } from '@angular/router';
import { AndroidControlService } from 'src/app/androidControl/androidControl.service';
import { Platform } from '@ionic/angular';

export interface RastreadorCoords {
  x: any;
  y: any;
}
export type WatchEyeResultsCallback = (
  position: RastreadorCoords | null,
  err?: any
) => void;

interface EyeTrackerPosition {
  scaleRef : Array<number>;
  rightRotation: number;
  leftRotation: number;
  upRotation: number;
  downRotation: number;
  leftOffset: number;
  rightOffset: number;
  downOffset: number;
  upOffset: number;
}

@Injectable({
  providedIn: 'root'
})
export class RastreadorOcularService extends DriverTemplate{

  x_n: any; //coordenada x 
  y_n: any; //coordenada y
  flagStarted = false; //auxilia no controle de start/stop do serviço
  face_data: any; //armazena face landmarks e face blendshapes
  connectionError = false; //erro de conexão
  x_android: any; // x_normalizado vindo do android
  y_android: any; // y_normalizado vindo do android

  private socket$: WebSocketSubject<any>; //configuração do WebSocket
  messageSubscription: any;
  messages: any;
  private imageSubject = new BehaviorSubject<string | null>(null);
  imageData$ = this.imageSubject.asObservable(); // Página pode escutar esse valor


  coordinates: RastreadorCoords; //coordenadas para uso

  //para simulação:
  private simulationTimeInterval: NodeJS.Timeout;
  simulate = false;

  x_p: any; //coordenada x calibrada
  y_p: any; //coordenada y calibrada

  eyeCalibrationMode = false;


   eyeUsePosition: EyeTrackerPosition = { //parâmetros de posição para uso normal do rastreador
      scaleRef: [0.35, 0.45],
      rightRotation: 0.07,
      leftRotation: 0.07,
      upRotation: 0.07,
      downRotation: 0.06,
      leftOffset: 0.7,
      rightOffset: 0.4,
      downOffset: 0.64,
      upOffset: 0.27,
    };
  
    eyeCalibratePosition: EyeTrackerPosition = { //parâmetros de posição para calibração do rastreador
      scaleRef: [0.39, 0.45],
      rightRotation: 0.07,
      leftRotation: 0.07,
      upRotation: 0.07,
      downRotation: 0.06,
      leftOffset: 0.7,
      rightOffset: 0.4,
      downOffset: 0.64,
      upOffset: 0.27,
    };


  start(options?: any): Promise<boolean> {
    this.myStatus.enabled = true;
    if (this.myStatus.running) {
      return Promise.resolve(false);
    } else {
      if (this.flagStarted === false) {
        console.log('RastreadorOcularService start');

        if(this.simulate){
          this.enableSimulation();
        }else{

          if (this.plt.is('desktop') || this.plt.is('mobileweb')) { //se está no computador, ativa comunicação com python
            console.log('RastreadorOcularService start - ativando comunicação com python');
            this.socket$ = webSocket({
            url: 'ws://localhost:8000/communicate'})    //URL do endpoint do WebSocket

            
          }else{ //ativa comunicação com android
            console.log('RastreadorOcularService start - ativando comunicação com android');
            this.android.startEyeTracker();
            this.watchEyeResponse(); //inicia o rastreador ocular
          }
          
          this.flagStarted = true; //faz com que não inicie duas vezes o rastreador ocular

          // Subscreve ao WebSocket para receber mensagens
        this.messageSubscription = this.getMessages().subscribe({
        next: (message) => { //message is json
          //console.log("recebido python message", message.char, message.data);
          if(message.char == "D"){
            //console.log('RastreadorOcularService - received D message', message.data);
            let x_normalizado = message.data[0];
            let y_normalizado = message.data[1];
            
            if(this.profile.profile.navSettingsBundle.bundleOptionsState.rastreadorCalibrationData != undefined) { //já tem calibração
              let cal = this.profile.profile.navSettingsBundle.bundleOptionsState.rastreadorCalibrationData;
              //console.log('RastreadorOcularService - calibração', cal);
               this.x_p = cal[0]*(x_normalizado) + cal[1];
               this.y_p = cal[2]*(y_normalizado) + cal[3];
               
            }else{
              //console.log('RastreadorOcularService - calibração padrão');
              this.x_p = 1424.5808593623926*(x_normalizado) + 902.1250814825771;
              this.y_p = -1402.366903571248*(y_normalizado) + 1103.2187383006503;
            }

            //console.log('RastreadorOcularService - x_p, y_p', this.x_p, this.y_p);

            this.x_n = this.x_p / 1920;
            this.y_n = this.y_p / 1080;

            //é possível colocar um filtro aqui, igual tinha no servidor python

            this.coordinates = {x: this.x_n, y: this.y_n};
            this.captureResultCallback({ //envia coordenadas para uso
              captureTime: performance.now(),
              coordinates: this.coordinates,
            });   
          } else if(message.char == "B"){
            //recebe face landmarks[0] e face blendshapes[1]
            //console.log("processFramesForQualityRastreador received: ", message.data);
            this.face_data = message.data;
            if(this.eyeCalibrationMode === true){ 
              //console.log("EyecalibrationMode true")
              this.vision.receiveMeshRastreador(this.face_data, this.eyeCalibratePosition);
            }else{
              //console.log("EyecalibrationMode false")
              this.vision.receiveMeshRastreador(this.face_data, this.eyeUsePosition);
            }

          } else if(message.char == "A"){
            //recebe frame
            //console.log('recebido frame: ', message.data);
            //coloca imagem na página
            this.imageSubject.next(message.data); // Notifica a página que chegou uma nova imagem
          }
          if(message.char == "E"){
            //recebe erro
            this.connectionError = true;
            console.log('Erro no rastreador ocular:', message.data);
          } else{
            this.connectionError = false;
          }
        },
        error: (err) => console.error('Erro no WebSocket:', err),
      });
        
    }
    
    }
    return  Promise.resolve(true);;
  }
  }


  stop(): Promise<boolean> { 
    if (this.myStatus.enabled) {
      console.log('RastreadorOcularService stop');
      if(this.simulate === true){
        this.disableSimulation();
      }else{
      //this.messageSubscription.unsubscribe();
      //this.closeConnection();
      console.log('RastreadorOcularService stop - fechando conexão');
      this.android.closeEyeTracker();
      this.flagStarted = false;
      this.myStatus.enabled = false;
      this.myStatus.running = false;
      this.myStatus.capturing = false;
      return Promise.resolve(true);
      }
    }else {
      return Promise.resolve(false);
    }
  }

  constructor(private profile: ProfileService, private vision: VisionService, private android: AndroidControlService, private plt: Platform) {
    super(); 
   }

   enableSimulation() {
    if (this.simulate) {
      // Add a red "simulation" text to the left botton of the page
      const div = document.createElement('div');
      div.id = 'eye-tracker-simulate';
      div.style.position = 'fixed';
      div.style.bottom = '0';
      div.style.left = '0';
      div.style.color = 'red';
      div.style.zIndex = '9999';
      div.style.fontSize = '2em';
      div.innerText = 'Simulation';
      document.body.appendChild(div);

      // Add event listener
      document.body.addEventListener(
        'mousemove',
        this.simulatedDataHandler,
        true
      );
      clearInterval(this.simulationTimeInterval);
      this.simulationTimeInterval = setInterval(() => {
        this.captureResultCallback({ //envia coordenadas para uso
          captureTime: performance.now(),
          coordinates: this.coordinates,
        });   
      }, 50);
    }
  }

  simulatedDataHandler = (event: MouseEvent) => {
    //if(Math.random() > 0.5) {
    // const windowOrigin = { x: window.scrollX, y: window.scrollY};
    // const windowSize = { x: window.innerWidth, y: window.innerHeight};
    const x = (event.clientX - window.scrollX) / window.innerWidth;
    const y = (event.clientY - window.scrollY) / window.innerHeight;
    this.coordinates = { x, y };
    //console.log('simulate', this.coordPeye);
    //this.callback(this.coordPeye);
    //}
  };

  disableSimulation() {
    if (this.simulate) {
      // remove the red "simulation" text
      const div = document.getElementById('eye-tracker-simulate');
      if (div) {
        div.remove();
      }
      // Clear interval
      clearInterval(this.simulationTimeInterval);
      // Remove event listener
      document.body.removeEventListener(
        'mousemove',
        this.simulatedDataHandler,
        true
      );
    }
  }

  async watchEyeResponse(): Promise<RastreadorCoords> {
    console.log('RastreadorOcularService watchEyeResponse');
      //pega coordenadas do Peye
      this.android.passCoordinates((val) => {
        const data: any = val;
        this.x_android = data.value.x; // x_normalizado vindo do android
        this.y_android = data.value.y; // y_normalizado vindo do android
        if(this.profile.profile.navSettingsBundle.bundleOptionsState.rastreadorCalibrationData != undefined) { //já tem calibração
          let cal = this.profile.profile.navSettingsBundle.bundleOptionsState.rastreadorCalibrationData;
          //console.log('RastreadorOcularService - calibração', cal);
          this.x_p = cal[0]*(data.value.x) + cal[1];
          this.y_p = cal[2]*(data.value.y) + cal[3];
        }else{
          this.x_p = 1585.8960056575513*(data.value.x) + 889.3270920410513;
          this.y_p = -1771.5007445275753*(data.value.y) + 1168.223691518639;
        }
        //console.log('RastreadorOcularService eyetracker resp', JSON.stringify(data));
        //console.log('peye streaming', JSON.stringify(val));
        const x = (this.x_p / 1920);
        const y = (this.y_p / 1080);
        //console.log('eye tracker streaming', x, y);
        this.coordinates = { x, y };
        this.callback({ x, y });
      });
  
      return this.coordinates;
    }
  
    callback(pos: RastreadorCoords) {
       console.log(
         'eyetracker callback coord',
         JSON.stringify(pos)
       );
      this.captureResultCallback({ //envia coordenadas para uso
              captureTime: performance.now(),
              coordinates: pos,
            });   
          }

  // Envia uma mensagem pelo WebSocket
  sendMessage(code: string, message: any): void {
    const jsonMessage = { "char": code, "data": message };
    if (this.socket$) {
      console.log('enviando python message', jsonMessage);
      this.socket$.next(jsonMessage);
    }
  }

  // Recebe mensagens do servidor
  getMessages(): Observable<any> {
    return this.socket$;
  }

  // Fecha o WebSocket
  closeConnection(): void {
    console.log('RastreadorOcularService Fechando conexão');
    if (this.socket$) {
      this.socket$.complete();
    }
  }

}
